export type StepState = "done" | "current" | "locked";

export interface EarningsInput {
  /** Validated contributions reached the payout threshold. */
  thresholdReached: boolean;
  /** A qualification test was submitted and waits for correction. */
  testSubmitted: boolean;
  testApproved: boolean;
  /** Money that can be requested now. */
  availableAmount: number;
  hasPendingRequest: boolean;
}

export interface EarningsSteps {
  contribute: StepState;
  test: StepState;
  payout: StepState;
  /** What the test step is waiting for, when it is the current one. */
  testPhase: "locked" | "todo" | "review" | "done";
  canRequestPayout: boolean;
}

/**
 * Where a contributor stands on the way to a payout. Pure, so the page and
 * its tests agree on every case.
 */
export function earningsSteps(input: EarningsInput): EarningsSteps {
  const { thresholdReached, testSubmitted, testApproved, availableAmount, hasPendingRequest } = input;
  const testPhase = !thresholdReached ? "locked" : testApproved ? "done" : testSubmitted ? "review" : "todo";
  return {
    contribute: thresholdReached ? "done" : "current",
    test: !thresholdReached ? "locked" : testApproved ? "done" : "current",
    payout: thresholdReached && testApproved ? "current" : "locked",
    testPhase,
    canRequestPayout: thresholdReached && testApproved && availableAmount > 0 && !hasPendingRequest,
  };
}
